import { render, staticRenderFns } from "./SofPage.vue?vue&type=template&id=f18040ec&scoped=true"
import script from "./SofPage.vue?vue&type=script&lang=js"
export * from "./SofPage.vue?vue&type=script&lang=js"
import style0 from "./SofPage.vue?vue&type=style&index=0&id=f18040ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18040ec",
  null
  
)

export default component.exports